import DOMPurify from 'dompurify';

export function sanitizeHtml(dirty: string): string {
  const config = {
    ALLOWED_TAGS: ['b', 'i', 'em', 'strong', 'u', 'a', 'br', 'p', 'span', 'li', 'ul', 'ol', 'mark', 'h1', 'h2', 'h3', 'h4', 'h5', 'h6'],
    ALLOWED_ATTR: ['href', 'target', 'rel', 'class', 'contenteditable', 'data-id', 'data-type', 'data-label'],
    ADD_ATTR: ['target', 'rel'],
    FORBID_TAGS: ['style', 'script', 'iframe', 'form', 'input'],
    FORBID_ATTR: ['style', 'onerror', 'onload', 'onclick'],
  };

  return DOMPurify.sanitize(dirty, config);
}
